import { useDispatch, useSelector } from 'react-redux';
import { useCallbackContext } from '../../../../contexts/CallbackContext';
import {
    clearPaymentStatusPopup, setShowPaymentStatusPopup, toggleCancelBtnLoading, toggleConfirmBtnLoading,
} from "../../../../features/paymentStatusPopup/paymentStatusPopupSlice";

const usePaymentStatusPopup = () => {
    const dispatch = useDispatch();
    const { registerCallback, unregisterCallback } = useCallbackContext();
    const { isVisible, config } = useSelector(state => state.sweetAlert);

    const showPaymentStatusPopup = (configObj, onConfirm, onCancel) => {
        const onConfirmKey = `confirm-${Date.now()}`;
        const onCancelKey = `cancel-${Date.now()}`;

        // Register callbacks with the generated keys
        registerCallback(onConfirmKey, onConfirm);
        registerCallback(onCancelKey, onCancel);

        // Set the configuration for SweetAlert, including the keys
        dispatch(setShowPaymentStatusPopup({
            configObj,
            onConfirmKey,
            onCancelKey,
        }));
    };

    const hidePaymentStatusPopup = () => {
        // Unregister callbacks to avoid memory leaks
        if (config.onConfirmKey) unregisterCallback(config.onConfirmKey);
        if (config.onCancelKey) unregisterCallback(config.onCancelKey);

        // Clear the SweetAlert configuration
        dispatch(clearPaymentStatusPopup());
    };

    const setConfirmBtnLoading = (isLoading) => {
        dispatch(toggleConfirmBtnLoading(isLoading));
    };

    const setCancelBtnLoading = (isLoading) => {
        dispatch(toggleCancelBtnLoading(isLoading));
    }

    return {
        isVisible,
        config,
        showPaymentStatusPopup,
        hidePaymentStatusPopup,
        setConfirmBtnLoading,
        setCancelBtnLoading
    };
};

export default usePaymentStatusPopup;
